




















import Vue from 'vue';
import ComponentPage from '@/components/page-constructor/ComponentPage.vue';
import ComponentUsageExample from '@/components/page-constructor/ComponentUsageExample.vue';
import AUploader from '@/components/AUploader.vue';

interface Data {
  basicUsageFile: File | null;
  modelAsArrayFiles: File[];
  acceptAttrSupportFile: File | null;
  disabledOptionFile: File | null;
}

export default Vue.extend({
  name: 'Uploader',
  components: {
    ComponentPage,
    ComponentUsageExample,
    AUploader,
  },
  data(): Data {
    return {
      basicUsageFile: null,
      modelAsArrayFiles: [],
      acceptAttrSupportFile: null,
      disabledOptionFile: null,
    };
  },
});
